module.exports = __webpack_public_path__ + "static/img/regCode-1.60b9f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/regCode-1.png
// module id = sfVT
// module chunks = 1